import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConsiderando } from '../interfaces/IConsiderando'

export class ConsiderandosService extends BaseService<IConsiderando> {
  constructor () {
    super({
      baseUrl: 'system/considerandos/'
    })
  }
}